import React, { PureComponent } from 'react'
import {
  Grid,
  TableRow,
  Table,
  TableHead,
  TableCell,
  Paper,
  Button,
  TableBody,
  Select,
  ListItem,
  TableFooter,
  Tooltip,
  TextField,
  InputAdornment,
  FormLabel,
} from '@material-ui/core'
import ReactSelect from 'react-select'
import MenuItem from '@material-ui/core/MenuItem/MenuItem'
import { connect } from 'react-redux'
import {
  getAllQuickBookAccountDetails,
  getProductSearch,
  saveAccountEntities,
  deleteAccountEntities,
  updateAccountEntities,
  updateBulkUpdate,
} from '../../actions/thirdParty'
import { openErrorMessage, openSuccessMessage } from '../../actions/message'
import ModalDialog from '../common/ModalDialog'
import SearchIcon from '@material-ui/icons/Search'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import Checkbox from '@material-ui/core/Checkbox/Checkbox'

class QuickBookCOAMapping extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      categoryId: '',
      COAMappingCategory: '',
      filterCategory: '',
      COAMappingProduct: { label: '', value: '' } || [],
      inventory: { label: '', value: '' } || [],
      sales: { label: '', value: '' } || [],
      suppliesAndMaterials: { label: '', value: '' } || [],
      products: '',
      quickBookAccountDetails: [],
      editIndex: -1,
      editForm: {},
      page: 1,
      rowsPerPage: 10,
      term: '',
      deleteItems: '',
      bulkUpdatedItem: [],
      mode: '',
      allCheckBoxes: [],
      allMassSelectBox: false,
      allAccountsList: props.allAccountsList || [],
    }
  }

  componentDidMount() {
    this.getAllQuickBookAccountDetails(0, 10)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.quickbookmethology !== nextProps.quickbookmethology) {
      this.getAllQuickBookAccountDetails(0, 10, '', '', nextProps.quickbookmethology)
      this.setState({
        editIndex: -1,
        page: 1,
        rowsPerPage: 10,
      })
    } else {
    }
  }

  getAllQuickBookAccountDetails = (
    start,
    limit,
    term,
    categoryId,
    quickbookmethology = this.props.quickbookmethology,
  ) => {
    const type =
      quickbookmethology === 'sync individual' || quickbookmethology === ''
        ? 'Product'
        : 'ProductCategory'
    const data = {
      categoryId: categoryId ? categoryId : '',
      start: start,
      limit: limit,
      type,
      term: term ? term : '',
    }
    this.props.dispatch(getAllQuickBookAccountDetails(data)).then((res) => {
      let allCheckBoxes = new Array(res.length).fill(false)
      this.setState({
        allCheckBoxes,
        allMassSelectBox: false,
        quickBookAccountDetails: res,
      })
    })
  }

  saveCOAMappingForProductCategory = (e) => {
    const {
      COAMappingCategory,
      COAMappingProduct,
      inventory,
      sales,
      suppliesAndMaterials,
      editForm,
      editIndex,
    } = this.state

    const { quickbookmethology } = this.props
    if (quickbookmethology === 'sync sales by product category') {
      var QBData = {
        accountType: 'ProductCategory',
        referenceId: COAMappingCategory,
        sales: sales.value,
        inventory: inventory.value,
        suppliesAndMaterials: suppliesAndMaterials.value,
        status: 'true',
      }
    } else {
      var QBData = {
        // eslint-disable-line
        accountType: 'Product',
        referenceId: COAMappingProduct.value,
        sales: sales.value,
        inventory: inventory.value,
        suppliesAndMaterials: suppliesAndMaterials.value,
        status: 'true',
      }
    }
    var newQbData = {
      accountType: 'ProductCategory',
      referenceId: editForm.id,
      sales: editForm.sales,
      inventory: editForm.inventory,
      suppliesAndMaterials: editForm.suppliesAndMaterials,
      status: 'true',
    }
    const apiUrl =
      editIndex >= 0 && editForm.accountType ? updateAccountEntities : saveAccountEntities

    this.props
      .dispatch(
        apiUrl(
          editIndex >= 0 && editForm.accountType
            ? editForm
            : editIndex >= 0 && !editForm.accountType
            ? newQbData
            : QBData,
        ),
      )
      .then((response) => {
        if (response != null) {
          this.props.dispatch(
            openSuccessMessage(
              editIndex >= 0
                ? 'COA Mapping have been updated successfully'
                : 'COA Mapping have been saved successfully',
            ),
          )
          this.getAllQuickBookAccountDetails(0, 10)
          this.onQuickBookClose()
          this.coaMappingModal.handleClose()
          this.setState({
            alertdisplay: response,
            COAMappingCategory: '',
            inventory: { label: '', value: '' } || [],
            sales: { label: '', value: '' } || [],
            suppliesAndMaterials: { label: '', value: '' } || [],
            COAMappingProduct: { label: '', value: '' },
            editForm: {},
            editIndex: -1,
          })
          this.timer = setTimeout((param) => {
            this.setState({
              alertdisplay: null,
            })
          }, 3000)
        }
      })
  }

  onQuickBookBulkUpdate = () => {
    const { bulkUpdatedItem } = this.state

    this.props.dispatch(updateBulkUpdate(bulkUpdatedItem)).then((response) => {
      if (response != null) {
        this.props.dispatch(openSuccessMessage('COA Mapping Bulk have been updated successfully'))
        this.onQuickBookClose()
        this.coaMappingModal.handleClose()
        this.setState({
          alertdisplay: response,
          inventory: { label: '', value: '' } || [],
          sales: { label: '', value: '' } || [],
          suppliesAndMaterials: { label: '', value: '' } || [],
          COAMappingProduct: { label: '', value: '' },
          mode: '',
          bulkUpdatedItem: [],
          allCheckBoxes: [],
          allMassSelectBox: false,
        })
        this.timer = setTimeout((param) => {
          this.setState({
            alertdisplay: null,
          })
        }, 3000)
      }
    })
  }

  onUpdate = (item, index) => {
    this.setState({
      editIndex: index,
      editForm: { ...item },
    })
  }

  onCancel = (item, index) => {
    this.setState({
      editIndex: -1,
      editForm: {},
    })
  }

  onDeleteCOAMapping = (item, index) => {
    const referenceId = this.state.deleteItems.referenceId
    this.props.dispatch(deleteAccountEntities(referenceId)).then(
      (response) => {
        this.props.dispatch(
          openSuccessMessage(
            this.props.quickbookmethology === 'sync individual'
              ? 'COA Mapping have been deleted successfully'
              : 'COA Mapping have been Reset successfully',
          ),
        )
        this.getAllQuickBookAccountDetails(0, 10)
        this.deleteModal.handleClose()
        this.resetModal.handleClose()
        this.timer = setTimeout((param) => {
          this.setState({
            alertdisplay: null,
          })
        }, 3000)
      },
      (err) => {
        this.deleteModal.handleClose()
        this.resetModal.handleClose()
        this.props.dispatch(openErrorMessage('Unable to delete please try again'))
      },
    )
  }

  deleteProduct = () => {
    this.onDeleteCOAMapping()
  }

  resetProduct = () => {
    this.onDeleteCOAMapping()
  }

  openDeleteModal = (item, i) => {
    this.deleteModal.handleClickOpen(item, i)
    this.setState({
      deleteItems: item,
    })
  }

  openReset = (item, i) => {
    this.resetModal.handleClickOpen(item, i)
    this.setState({
      deleteItems: item,
    })
  }

  handleEditChange = (key, e) => {
    let { editForm } = this.state

    const value = !!e && e.value && e.value ? e.value : ''

    this.setState({
      editForm: {
        ...editForm,
        [key]: value,
      },
    })
  }

  handleCategoriesChange = (e) => {
    const categoryId = e.target.value
    this.getProductSearchByCategories(categoryId)
    this.setState({
      [e.target.name]: e.target.value,
      inventory: { label: '', value: '' } || [],
      sales: { label: '', value: '' } || [],
      suppliesAndMaterials: { label: '', value: '' } || [],
      COAMappingProduct: { label: '', value: '' } || [],
    })
  }

  handleAllCategoriesChange = (e) => {
    const categoryId = e.target.value
    const { term } = this.state
    this.getAllQuickBookAccountDetails(0, 10, term, categoryId)
    this.setState({
      [e.target.name]: e.target.value,
      inventory: { label: '', value: '' } || [],
      sales: { label: '', value: '' } || [],
      suppliesAndMaterials: { label: '', value: '' } || [],
      COAMappingProduct: { label: '', value: '' } || [],
      categoryId: categoryId,
    })
  }

  handleSearchChange = (key, e) => {
    let { bulkUpdatedItem = [], mode } = this.state
    if (mode === 'massUpdate') {
      bulkUpdatedItem = bulkUpdatedItem.map((item) => {
        item[key] = !!e && e.value && e.value ? e.value : ''
        return item
      })
      this.setState({
        bulkUpdatedItem,
        [key]: e,
      })
    } else {
      this.setState({
        [key]: e,
      })
    }
  }

  getProductSearchByCategories = (categoryId) => {
    this.props.dispatch(getProductSearch(categoryId)).then((res) => {
      this.setState({
        products: res && res.values,
      })
    })
  }

  handleChangePage = (page, count) => (event) => {
    if (
      count >= 1 &&
      count <=
        Math.ceil(
          this.state.quickBookAccountDetails &&
            this.state.quickBookAccountDetails.length + 1 / this.state.rowsPerPage,
        )
    ) {
      this.setState({
        page: count,
      })
      this.getAllQuickBookAccountDetails((count - 1) * 10, this.state.rowsPerPage)
    }
    this.forceUpdate()
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value })
    this.forceUpdate()
    this.getAllQuickBookAccountDetails((this.state.page - 1) * 10, event.target.value)
  }

  onQuickBookSave = () => {
    this.saveCOAMappingForProductCategory()
  }

  onQuickBookClose = () => {
    this.getAllQuickBookAccountDetails(0, 10, '', this.state.categoryId)
    setTimeout(
      () =>
        this.setState({
          coaMappingModal: null,
          COAMappingCategory: this.state.mode === 'add' ? '' : this.state.COAMappingCategory,
          products: '',
          COAMappingProduct: { label: '', value: '' },
          inventory: { label: '', value: '' } || [],
          sales: { label: '', value: '' } || [],
          suppliesAndMaterials: { label: '', value: '' } || [],
          mode: '',
        }),
      100,
    )
  }

  openQuickBookSaveModal = () => {
    this.coaMappingModal.handleClickOpen()
    this.setState({
      mode: 'add',
    })
  }

  openQuickBookEditModal = () => {
    this.coaMappingModal.handleClickOpen()
    this.setState({
      mode: 'massUpdate',
    })
  }

  searchCOAMappingData = (e, key) => {
    const { term, categoryId } = this.state
    this.getAllQuickBookAccountDetails(0, 10, term, categoryId)
  }

  keyPress = (e, key) => {
    if (e.keyCode === 13) {
      const { term, categoryId } = this.state
      this.getAllQuickBookAccountDetails(0, 10, term, categoryId)
    }
  }

  handleInputSearchChange = (e) => {
    this.setState({
      term: e.target.value,
    })
  }

  allSelectMassUpdate = () => {
    const { allMassSelectBox, allCheckBoxes, quickBookAccountDetails } = this.state
    let allChecked = new Array(allCheckBoxes.length).fill(!allMassSelectBox)
    this.setState({
      allMassSelectBox: !allMassSelectBox,
      allCheckBoxes: allChecked,
      mode: '',
      bulkUpdatedItem: !allMassSelectBox ? JSON.parse(JSON.stringify(quickBookAccountDetails)) : [],
    })
  }

  handleCheckBoxChange = (id, index) => (e) => {
    const { bulkUpdatedItem, quickBookAccountDetails } = this.state
    let { allCheckBoxes } = this.state
    if (e.target.checked) {
      allCheckBoxes[index] = true
      bulkUpdatedItem.push(id)
    } else {
      allCheckBoxes[index] = false
      index = bulkUpdatedItem.indexOf(index)
      bulkUpdatedItem.splice(index, 1)
    }
    this.setState({
      bulkUpdatedItem,
      mode: '',
      allCheckBoxes,
      allMassSelectBox: quickBookAccountDetails.length === bulkUpdatedItem.length,
    })
    this.forceUpdate()
  }

  filterAccountById = (accountList, subAccountList, accountId) => {
    let account
    if (accountList && subAccountList) {
      account = subAccountList.find((account) => account.accountId === accountId)
    }

    return account ? account.accountName : '-'
  }

  getAccountNameById = (options, accountId) => {
    let account = null
    if (options.length > 0) {
      account = options.find((a) => a.value === accountId)
    }
    return account ? account.label : '-'
  }

  render() {
    const {
      categories = [],
      getQuickBookAccounts = [],
      quickbookmethology,
      allAccountsList = [],
    } = this.props
    const {
      COAMappingCategory,
      filterCategory,
      COAMappingProduct,
      inventory,
      sales,
      suppliesAndMaterials,
      products,
      quickBookAccountDetails = [],
      editForm = {},
      editIndex,
      bulkUpdatedItem,
      mode,
    } = this.state

    const setFields =
      quickbookmethology && quickbookmethology === 'sync sales by product category'
        ? COAMappingCategory &&
          COAMappingProduct &&
          ((inventory && inventory.value) ||
            (sales && sales.value) ||
            (suppliesAndMaterials && suppliesAndMaterials.value))
          ? true
          : false // eslint-disable-line
        : COAMappingCategory &&
          COAMappingProduct &&
          COAMappingProduct.value &&
          ((inventory && inventory.value) ||
            (sales && sales.value) ||
            (suppliesAndMaterials && suppliesAndMaterials.value))
        ? true
        : false // eslint-disable-line

    const bulkSetFields =
      (inventory && inventory.value) ||
      (sales && sales.value) ||
      (suppliesAndMaterials && suppliesAndMaterials.value)
        ? true
        : false // eslint-disable-line

    const massUpdateBtnClass = bulkUpdatedItem.length ? 'enabled' : 'disabled'
    let updatedProductOptions =
      products &&
      products.map((item) => {
        return { label: item.name, value: item.id }
      })
    const updatedProjects = [{ label: 'Select All', value: '' }, ...updatedProductOptions]

    let inventoryOptions =
      allAccountsList.length > 0 &&
      allAccountsList.filter(
        (a) => a.accountType == 'OTHER_CURRENT_ASSET' || a.accountType == 'OtherCurrentAsset',
      ).length > 0 &&
      allAccountsList
        .filter(
          (a) => a.accountType == 'OTHER_CURRENT_ASSET' || a.accountType == 'OtherCurrentAsset',
        )
        .map((item) => {
          return { label: item.accountName, value: item.accountId }
        })

    const updatedInventory = [{ label: 'Select Any', value: '' }, ...(inventoryOptions || [])]

    let salesOptions =
      allAccountsList.length > 0 &&
      allAccountsList.filter((a) => a.accountType == 'INCOME' || a.accountType == 'Income').length >
        0 &&
      allAccountsList
        .filter((a) => a.accountType == 'INCOME' || a.accountType == 'Income')
        .map((item) => {
          return { label: item.accountName, value: item.accountId }
        })
    const updatedSales = [{ label: 'Select Any', value: '' }, ...(salesOptions || [])]

    let suppliesAndMaterialsOptions =
      allAccountsList.length > 0 &&
      allAccountsList.filter(
        (a) => a.accountType == 'COST_OF_GOODS_SOLD' || a.accountType == 'CostOfGoodsSold',
      ).length > 0 &&
      allAccountsList
        .filter((a) => a.accountType == 'COST_OF_GOODS_SOLD' || a.accountType == 'CostOfGoodsSold')
        .map((item) => {
          return { label: item.accountName, value: item.accountId }
        })
    const updatedSuppliesAndMaterials = [
      { label: 'Select Any', value: '' },
      ...(suppliesAndMaterialsOptions || []),
    ]

    let total = (quickBookAccountDetails && quickBookAccountDetails.length + 1) || 0
    const pages = Math.ceil(total / this.state.rowsPerPage)
    let page = this.state.page

    return (
      <div>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="margin-top-small">
            <ListItem>
              {quickbookmethology && quickbookmethology === 'sync sales by product category' ? (
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Button
                    className="primary-button margin pull-right"
                    onClick={this.openQuickBookSaveModal.bind(this)}
                  >
                    Add
                  </Button>
                </Grid>
              ) : (
                <Grid container>
                  <Grid item xs={12} sm={12} md={5} lg={3} style={{ marginTop: '10px' }}>
                    <Select
                      value={filterCategory}
                      name={'filterCategory'}
                      onChange={this.handleAllCategoriesChange}
                      MenuProps={{ className: 'no-backdrop-select' }}
                      style={{ minWidth: 200, marginLeft: 10 }}
                      displayEmpty={true}
                    >
                      <MenuItem value="">All Categories</MenuItem>
                      {categories &&
                        categories.map((Categ, i) => {
                          return (
                            <MenuItem key={i} value={Categ.id}>
                              {Categ.name}
                            </MenuItem>
                          )
                        })}
                    </Select>
                  </Grid>
                  <Grid item xs={12} sm={12} md={7} lg={6} className="coa_mapping_search">
                    <TextField
                      placeholder="Search ..."
                      type="search"
                      margin="normal"
                      variant="outlined"
                      style={{ cursor: 'pointer' }}
                      onKeyDown={this.keyPress}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      value={this.state.term || ''}
                      name={'term'}
                      onChange={this.handleInputSearchChange}
                    />
                    <Button
                      className="primary-button search_For_COAMapping"
                      onClick={this.searchCOAMappingData}
                    >
                      Search
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    style={{ textAlign: 'right', marginTop: '10px' }}
                  >
                    <Button
                      className="primary-button margin"
                      onClick={this.openQuickBookEditModal.bind(this)}
                      disabled={massUpdateBtnClass === 'disabled' ? true : false}
                    >
                      Mass Update
                    </Button>
                    <Button
                      className="primary-button margin"
                      onClick={this.openQuickBookSaveModal.bind(this)}
                    >
                      Add
                    </Button>
                  </Grid>
                </Grid>
              )}
            </ListItem>
            <div className="table-scroll">
              <Table>
                {quickbookmethology && quickbookmethology === 'sync sales by product category' ? (
                  <TableHead>
                    <TableRow>
                      <TableCell>Category Name</TableCell>
                      <TableCell>Inventory Account</TableCell>
                      <TableCell>Sales Account</TableCell>
                      <TableCell>Cogs Account</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                ) : (
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Checkbox
                          onChange={this.allSelectMassUpdate.bind(this)}
                          checked={this.state.allMassSelectBox}
                        />
                      </TableCell>
                      <TableCell>Category Name</TableCell>
                      <TableCell>Product Name</TableCell>
                      <TableCell>Inventory Account</TableCell>
                      <TableCell>Sales Account</TableCell>
                      <TableCell>Cogs Account</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                )}
                {quickbookmethology && quickbookmethology === 'sync sales by product category' ? (
                  <TableBody>
                    {quickBookAccountDetails &&
                      quickBookAccountDetails.map((item, i) => {
                        return (
                          <TableRow key={i}>
                            <TableCell>{item.referenceName}</TableCell>
                            <TableCell>
                              {editIndex === i ? (
                                <ReactSelect
                                  name="inventory"
                                  id="inventory"
                                  value={editForm.inventory}
                                  onChange={this.handleEditChange.bind(this, 'inventory')}
                                  options={inventoryOptions}
                                  placeholder="Select Any"
                                  MenuProps={{ className: 'no-backdrop-select' }}
                                  fullWidth={true}
                                  isClearable={true}
                                  displayEmpty={true}
                                />
                              ) : //item.inventory? this.filterAccountById(getQuickBookAccounts, getQuickBookAccounts.OtherCurrentAsset, item.inventory) :'-'
                              item.inventory ? (
                                this.getAccountNameById(inventoryOptions, item.inventory)
                              ) : (
                                '-'
                              )}
                            </TableCell>
                            <TableCell>
                              {
                                editIndex === i ? (
                                  <ReactSelect
                                    name="sales"
                                    id="sales"
                                    value={editForm.sales}
                                    onChange={this.handleEditChange.bind(this, 'sales')}
                                    options={salesOptions}
                                    placeholder="Select Any"
                                    MenuProps={{ className: 'no-backdrop-select' }}
                                    fullWidth={true}
                                    isClearable={true}
                                    displayEmpty={true}
                                  />
                                ) : item.sales ? (
                                  this.getAccountNameById(salesOptions, item.sales)
                                ) : (
                                  '-'
                                )
                                //item.sales?this.filterAccountById(getQuickBookAccounts, getQuickBookAccounts.Income, item.sales):'-'
                              }
                            </TableCell>
                            <TableCell>
                              {
                                editIndex === i ? (
                                  <ReactSelect
                                    name="suppliesAndMaterials"
                                    id="suppliesAndMaterials"
                                    value={editForm.suppliesAndMaterials}
                                    onChange={this.handleEditChange.bind(
                                      this,
                                      'suppliesAndMaterials',
                                    )}
                                    options={suppliesAndMaterialsOptions}
                                    placeholder="Select Any"
                                    MenuProps={{ className: 'no-backdrop-select' }}
                                    fullWidth={true}
                                    isClearable={true}
                                    displayEmpty={true}
                                  />
                                ) : item.suppliesAndMaterials ? (
                                  this.getAccountNameById(
                                    suppliesAndMaterialsOptions,
                                    item.suppliesAndMaterials,
                                  )
                                ) : (
                                  '-'
                                )
                                //item.suppliesAndMaterials?this.filterAccountById(getQuickBookAccounts, getQuickBookAccounts.CostOfGoodsSold, item.suppliesAndMaterials):'-'
                              }
                            </TableCell>
                            <TableCell>
                              {editIndex === i ? (
                                <div>
                                  <Button
                                    className="primary-button margin"
                                    onClick={(e) => this.saveCOAMappingForProductCategory(item, i)}
                                  >
                                    &nbsp;Save
                                  </Button>
                                  <Button
                                    className="danger-button margin"
                                    onClick={(e) => this.onCancel(item, i)}
                                  >
                                    {' '}
                                    Cancel{' '}
                                  </Button>
                                </div>
                              ) : (
                                <Grid>
                                  <Button
                                    className="primary-button "
                                    onClick={(e) => this.onUpdate(item, i)}
                                  >
                                    <EditIcon />
                                  </Button>
                                  {item.inventory || item.sales || item.suppliesAndMaterials ? (
                                    <Button
                                      className="danger-button margin"
                                      onClick={(e) => this.openReset(item, i)}
                                    >
                                      <DeleteIcon />
                                    </Button>
                                  ) : (
                                    ''
                                  )}
                                </Grid>
                              )}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                  </TableBody>
                ) : (
                  <TableBody>
                    {quickBookAccountDetails &&
                      quickBookAccountDetails.map((item, i) => {
                        return (
                          <TableRow key={i}>
                            <TableCell>
                              <Checkbox
                                onChange={this.handleCheckBoxChange(item, i)}
                                checked={this.state.allCheckBoxes[i]}
                              />
                            </TableCell>
                            <TableCell>{item.categoryName}</TableCell>
                            <TableCell>{item.referenceName}</TableCell>
                            <TableCell>
                              {
                                editIndex === i ? (
                                  <ReactSelect
                                    name="inventory"
                                    id="inventory"
                                    value={editForm.inventory}
                                    onChange={this.handleEditChange.bind(this, 'inventory')}
                                    options={inventoryOptions}
                                    placeholder="Select Any"
                                    MenuProps={{ className: 'no-backdrop-select' }}
                                    fullWidth={true}
                                    isClearable={true}
                                    displayEmpty={true}
                                  />
                                ) : item.inventory ? (
                                  this.getAccountNameById(inventoryOptions, item.inventory)
                                ) : (
                                  '-'
                                )
                                //item.inventory? this.filterAccountById(getQuickBookAccounts, getQuickBookAccounts.OtherCurrentAsset, item.inventory) :'-'
                              }
                            </TableCell>
                            <TableCell>
                              {
                                editIndex === i ? (
                                  <ReactSelect
                                    name="sales"
                                    id="sales"
                                    value={editForm.sales}
                                    onChange={this.handleEditChange.bind(this, 'sales')}
                                    options={salesOptions}
                                    placeholder="Select Any"
                                    MenuProps={{ className: 'no-backdrop-select' }}
                                    fullWidth={true}
                                    isClearable={true}
                                    displayEmpty={true}
                                  />
                                ) : item.sales ? (
                                  this.getAccountNameById(salesOptions, item.sales)
                                ) : (
                                  '-'
                                )
                                //item.sales?this.filterAccountById(getQuickBookAccounts, getQuickBookAccounts.Income, item.sales):'-'
                              }
                            </TableCell>
                            <TableCell>
                              {
                                editIndex === i ? (
                                  <ReactSelect
                                    name="suppliesAndMaterials"
                                    id="suppliesAndMaterials"
                                    value={editForm.suppliesAndMaterials}
                                    onChange={this.handleEditChange.bind(
                                      this,
                                      'suppliesAndMaterials',
                                    )}
                                    options={suppliesAndMaterialsOptions}
                                    placeholder="Select Any"
                                    MenuProps={{ className: 'no-backdrop-select' }}
                                    fullWidth={true}
                                    isClearable={true}
                                    displayEmpty={true}
                                  />
                                ) : item.suppliesAndMaterials ? (
                                  this.getAccountNameById(
                                    suppliesAndMaterialsOptions,
                                    item.suppliesAndMaterials,
                                  )
                                ) : (
                                  '-'
                                )
                                //item.suppliesAndMaterials?this.filterAccountById(getQuickBookAccounts, getQuickBookAccounts.CostOfGoodsSold, item.suppliesAndMaterials):'-'
                              }
                            </TableCell>
                            <TableCell>
                              {editIndex === i ? (
                                <div>
                                  <Button
                                    className="primary-button margin"
                                    onClick={(e) => this.saveCOAMappingForProductCategory(item, i)}
                                  >
                                    &nbsp;Save
                                  </Button>
                                  <Button
                                    className="danger-button margin"
                                    onClick={(e) => this.onCancel(item, i)}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              ) : (
                                <Grid>
                                  <Button
                                    className="primary-button "
                                    onClick={(e) => this.onUpdate(item, i)}
                                  >
                                    <EditIcon />
                                  </Button>
                                  <Button
                                    className="danger-button margin"
                                    onClick={(e) => this.openDeleteModal(item, i)}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </Grid>
                              )}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                  </TableBody>
                )}
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={3} />
                    <TableCell colSpan={5}>
                      <ul className="pagination">
                        <li>Rows per page</li>
                        <li>
                          <Select
                            value={this.state.rowsPerPage}
                            onChange={this.handleChangeRowsPerPage}
                            displayEmpty
                          >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={30}>30</MenuItem>
                          </Select>
                        </li>
                        <li>
                          {this.state.page} of {pages}
                        </li>
                        <li>
                          <Tooltip title="Previous">
                            <Button onClick={this.handleChangePage('prv', page - 1)}>
                              <i className="material-icons">chevron_left</i>
                            </Button>
                          </Tooltip>
                        </li>
                        <li>
                          <Tooltip title="Next">
                            <div>
                              <Button
                                onClick={this.handleChangePage('next', page + 1)}
                                disabled={page === pages ? true : false}
                              >
                                <i className="material-icons">chevron_right</i>
                              </Button>
                            </div>
                          </Tooltip>
                        </li>
                      </ul>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          </Paper>
        </Grid>
        <ModalDialog
          title={mode === 'add' ? 'Add COA Mapping' : 'Bulk Update COA Mapping'}
          ref={(c) => (this.coaMappingModal = c)}
          onConfirm={
            mode === 'add'
              ? setFields
                ? this.onQuickBookSave
                : null
              : bulkSetFields
              ? this.onQuickBookBulkUpdate
              : null
          }
          confirmText={'Save'}
          paperStyle={{ maxHeight: '70%', minHeight: '50%' }}
          products={products}
          onClose={this.onQuickBookClose}
        >
          <Grid>
            {mode === 'add' ? (
              quickbookmethology && quickbookmethology === 'sync sales by product category' ? (
                ''
              ) : (
                <ListItem>
                  <Grid container>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <FormLabel component="legend">Categories</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin">
                      <Select
                        value={COAMappingCategory}
                        name={'COAMappingCategory'}
                        onChange={this.handleCategoriesChange}
                        MenuProps={{ className: 'no-backdrop-select' }}
                        fullWidth={true}
                        displayEmpty={true}
                      >
                        <MenuItem value={''}>Select Category</MenuItem>
                        {categories &&
                          categories.map((Categ, i) => {
                            return (
                              <MenuItem key={i} value={Categ.id}>
                                {Categ.name}
                              </MenuItem>
                            )
                          })}
                      </Select>
                    </Grid>
                  </Grid>
                </ListItem>
              )
            ) : (
              ''
            )}
            {mode === 'add' ? (
              quickbookmethology && quickbookmethology === 'sync sales by product category' ? (
                <ListItem>
                  <Grid container>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <FormLabel component="legend">Categories</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin">
                      <Select
                        value={COAMappingCategory}
                        name={'COAMappingCategory'}
                        onChange={this.handleCategoriesChange}
                        MenuProps={{ className: 'no-backdrop-select' }}
                        displayEmpty={true}
                        fullWidth={true}
                      >
                        <MenuItem value={''}>Select Category</MenuItem>
                        {categories &&
                          categories.map((Categ, i) => {
                            return (
                              <MenuItem key={i} value={Categ.id}>
                                {Categ.name}
                              </MenuItem>
                            )
                          })}
                      </Select>
                    </Grid>
                  </Grid>
                </ListItem>
              ) : (
                <ListItem>
                  <Grid container>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <FormLabel component="legend">Products</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin">
                      <ReactSelect
                        name="COAMappingProduct"
                        id="COAMappingProduct"
                        value={COAMappingProduct}
                        onChange={this.handleSearchChange.bind(this, 'COAMappingProduct')}
                        options={updatedProjects}
                        placeholder="Select Projects"
                        MenuProps={{ className: 'no-backdrop-select' }}
                        fullWidth={true}
                        displayEmpty={true}
                        isClearable={true}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              )
            ) : (
              ''
            )}
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormLabel component="legend">Inventory Account</FormLabel>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin">
                  <ReactSelect
                    name="inventory"
                    id="inventory"
                    value={inventory}
                    onChange={this.handleSearchChange.bind(this, 'inventory')}
                    options={updatedInventory}
                    placeholder="Select Any"
                    MenuProps={{ className: 'no-backdrop-select' }}
                    fullWidth={true}
                    displayEmpty={true}
                    isClearable={true}
                  ></ReactSelect>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormLabel component="legend">Sales Account</FormLabel>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin">
                  <ReactSelect
                    name="sales"
                    id="sales"
                    value={sales}
                    onChange={this.handleSearchChange.bind(this, 'sales')}
                    options={updatedSales}
                    placeholder="Select Any"
                    MenuProps={{ className: 'no-backdrop-select' }}
                    fullWidth={true}
                    displayEmpty={true}
                    isClearable={true}
                  ></ReactSelect>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormLabel component="legend">Cogs Account</FormLabel>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin">
                  <ReactSelect
                    name="suppliesAndMaterials"
                    id="suppliesAndMaterials"
                    value={suppliesAndMaterials}
                    onChange={this.handleSearchChange.bind(this, 'suppliesAndMaterials')}
                    options={updatedSuppliesAndMaterials}
                    placeholder="Select Any"
                    MenuProps={{ className: 'no-backdrop-select' }}
                    fullWidth={true}
                    displayEmpty={true}
                    isClearable={true}
                  ></ReactSelect>
                </Grid>
              </Grid>
            </ListItem>
          </Grid>
        </ModalDialog>
        <ModalDialog
          title={'Delete Product'}
          ref={(c) => (this.deleteModal = c)}
          onConfirm={(e) => this.deleteProduct(e)}
          confirmText={'Confirm'}
        >
          * Are you sure want to delete product COA Mapping?
        </ModalDialog>
        <ModalDialog
          title={'Delete '}
          ref={(c) => (this.resetModal = c)}
          onConfirm={(e) => this.resetProduct(e)}
          confirmText={'Confirm'}
        >
          * Are you sure want to delete product category COA Mapping?
        </ModalDialog>
      </div>
    )
  }
}

export default connect((state) => ({ dispatch: state.dispatch }))(QuickBookCOAMapping)



// WEBPACK FOOTER //
// ./src/components/QuickBook/QuickBookCOAMapping.js